import i18n from '@/i18n';

const PageDashboardPem = () =>
  import(
    /* webpackChunkName: "dashboardPem" */ '@/pages/dashboardPem/DashboardPem.vue'
  );
const DashboardPemTop = () =>
  import(
    /* webpackChunkName: "dashboardPem" */ '@/pages/dashboardPem/DashboardPemTop.vue'
  );
const DashboardPemFilters = () =>
  import(
    /* webpackChunkName: "dashboardPem" */ '@/pages/dashboardPem/DashboardPemFilters'
  );

export const REQUESTS_DASHBOARD_PEM_ROUTE_NAME = 'requests-dashboard-pem';

export default {
  getDashboardPemRoute() {
    return {
      path: 'dashboardPem',
      name: REQUESTS_DASHBOARD_PEM_ROUTE_NAME,
      components: {
        default: PageDashboardPem,
        top: DashboardPemTop,
        'right-drawer': DashboardPemFilters,
      },
      meta: {
        authorizations: ['isMy360'],
        isHidden: false,
        title: 'dashboardPem',
        icon: i18n.t('message.dashboardPem.icon'),
      },
    };
  },
};
